import { CandidateData } from '../../../../types/candidates';

const filterById = (singleCandidate: CandidateData, candidateId: number) => {
  if (typeof candidateId !== 'number') return false;
  return singleCandidate.Id === candidateId;
};

export default filterById;
